import {
  any,
  allPass,
  all,
  equals,
  empty,
  includes,
  juxt,
  length,
  map,
  not,
  path,
  pathEq,
  pathOr,
  pipe,
  propEq,
  reject,
  unless,
  filter,
  pickBy,
  prop,
  values,
  either
} from 'ramda'

import { utils } from '@digital-commerce/shared-utils'

const { getTopLevelItems } = utils.cart

const _hasShippingFee = (item) => propEq('category', 'MOBILITY_SHIPPING')(item)
const hasJustOneItem = pipe(length, equals(1))

const isCartEligibleForOnlineReservation = (cart) =>
  pipe(pathOr([], ['root', 'eligibleFulfillmentMethods']), includes('RESERVE_ONLINE'))(cart)

const isStorePickupEligible = pathEq(['fulfillment', 'inStorePickupEligible'], true)
const getProductOrderType = path(['productOrder', 'type'])

const isRenewalOrderType = pipe(getProductOrderType, equals('RENEWAL'))
const isTradeIn = propEq(['category'], 'MOBILITY_TRADE_IN')
const isBringItBack = propEq(['category'], 'MOBILITY_BRING_IT_BACK')

const _getMobilityOffers = (cart) =>
  pipe(
    getTopLevelItems,
    filter(pathEq(['category'], 'MOBILITY_OFFER')),
    map((offer) => ({
      ...offer,
      items: pickBy((val, key) => includes(key, offer.items), cart.items)
    }))
  )(cart)

const isProductsReserveInStoreElegible = (cart) =>
  pipe(
    getTopLevelItems,
    reject(_hasShippingFee),
    unless(hasJustOneItem, empty),
    map(allPass([isStorePickupEligible, isRenewalOrderType])),
    any(equals(true))
  )(cart)

const getMobilityOffersWithOrbit = pipe(
  _getMobilityOffers,
  filter(pipe(prop('items'), values, either(any(isTradeIn), any(isBringItBack))))
)

const hasOrbitOffers = (service) => {
  const orbitOffers = getMobilityOffersWithOrbit(service)
  return orbitOffers.length > 0
}

const dontHasOrbitOffers = pipe(hasOrbitOffers, not)

const validators = juxt([
  isCartEligibleForOnlineReservation,
  isProductsReserveInStoreElegible,
  dontHasOrbitOffers
])

export const isReserveInStoreEligible = (cart) => all(equals(true))(validators(cart))
